<template>
    <div>
        <div v-if="report">
            <div id="nav">
                <ul class="report-nav">
                    <li>
                        <a @click="exitReport">
                            <span class="mdi mdi-exit-to-app mdi-flip-h text-muted mr-1"></span> Exit Report
                        </a>
                    </li>
                    <li>
                        <a @click="selectHome" class="divider pb-3 mb-2" style="border-bottom: 1px solid #ccc;">
                            <span class="mdi mdi-home-outline text-muted mr-1"></span> {{ report.job_reference }} - Report Home
                        </a>
                    </li>                  
                    <li v-for="(section) in report.sections" :key="section.number">
                        <a @click="selectSection(section)" :style="'background: ' + section.color_code">
                            {{ section.number }} {{ section.name }}
                        </a>
                    </li>
                </ul>
            </div>
            <div style="margin-left: 300px;">
                <!-- <router-view></router-view> -->
                <ReportHome ref="reportHome"
                    :report="report"
                    v-if="report && selectedView == 'Home'" />

                <ReportSection ref="sectionEdit"
                    :sectionProp="currentSection" 
                    :sectionNumber="currentSection.number" 
                    :key="currentSection.number"
                    v-on:contentchanged="onSectionEditContentChanged"
                    v-if="currentSection && selectedView == 'Section'" />
            </div>
        </div>

        <LoadingIndicator v-if="viewState == 'Busy'" :message="loadingMessage" />
    </div>
</template>

<script>
    import ReportService from '../../services/reports/reportService'
    import ReportSidebar from '../../components/reports/ReportSidebar'
    import ReportSection from '../../components/reports/ReportSection'
    import ReportHome from '../../components/reports/ReportHome'

    export default {
        props: {
            jobReference: String
        },
        components: {
            ReportSidebar,
            ReportHome,
            ReportSection
        },
        data() {
            return {
                viewState: 'Idle',
                selectedView: 'Home',
                loadingMessage: '',
                error: null,
                report: null,
                currentSection: null
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                this.loadingMessage = `Getting Report ${this.jobReference}...`
                let report = await ReportService.getReportByJobReference(this.jobReference)

                // If this report is pending, build it first
                if (report.report_status == 'Pending') {
                    this.loadingMessage = 'Just a moment, creating Report content and comparables...'
                    report = await ReportService.buildReportByJobReference(this.jobReference)
                }

                let orderedSections = report.sections.map((s) => {
                    return { ...s, fNumber: parseFloat(s.number) }
                })
                report.sections = this.$_.orderBy(orderedSections, [ 'fNumber', 'asc' ])

                this.report = report
                this.currentSection = this.report.sections[0]
                this.viewState = 'Idle'
            } catch (err) {
                console.error('Error loading report', err)
                this.viewState = 'Error'
                this.error = err                
            }
        },
        methods: {
            selectHome() {
                this.selectedView = 'Home'
            },
            selectSection(section) {
                this.selectedView = 'Section'
                this.currentSection = section
            },
            exitReport() {
                this.$bvModal
                    .msgBoxConfirm('Exit this report?', { centered: true })
                    .then(async (confirm) => {
                        if (confirm)
                            this.$router.push('/')
                    })
            },
            async onSectionEditContentChanged(sender, sectionNumber, content) {
                try {
                    sender.setIsUpdating(true)

                    await ReportService.updateReportSectionContent(this.jobReference, sectionNumber, content)
                    sender.setUnchanged()

                    this.$bvToast.toast(`Section ${sectionNumber} content saved`, {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (err) {
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t save your content', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
                
                sender.setIsUpdating(false)
            }
        }
    }
</script>

<style lang="scss">
    ul.report-nav {
        overflow-y: scroll;
        height: 100%;
        margin-top: -70px;
        margin-left: -30px;        
        max-width: 300px;
        background: white;        
        
        li:first-child {
            margin-top: 54px;
        }

        li {            
            margin-top: 0;
            margin-bottom: 0 !important;
            margin-left: 0;

            a {
                cursor: pointer;
                display: block;
                padding: 0.35em 1em;
            }
        }
    }
</style>